<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">积分奖励管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>奖惩类型：</label>
          <el-select v-model="preType" placeholder="Select" style="width: 8em" @change="typeChange">
            <el-option v-for="item in preTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>行为：</label>
          <el-select v-model="action" placeholder="Select" style="width: 8em">
            <el-option v-for="item in actionArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">

        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
<!--          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
          <el-table-column prop="" label="奖惩类型" v-if="checkColList.indexOf('奖惩类型') > -1">
            <template #default="scope">
              {{scope.row.type > 0?'奖励':'惩罚'}}
            </template>
          </el-table-column>
          <el-table-column prop="" label="行为" v-if="checkColList.indexOf('行为') > -1">
            <template #default="scope">
              {{scope.row.action == 1?'聊天':scope.row.action == 2?'纸条':scope.row.action == 3?'动态':''}}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="奖惩操作" v-if="checkColList.indexOf('奖惩操作') > -1" width="200"></el-table-column>
          <el-table-column prop="integral" label="积分数量" v-if="checkColList.indexOf('积分数量') > -1"></el-table-column>
          <el-table-column prop="" label="单位" v-if="checkColList.indexOf('单位') > -1">
            <template #default="scope">
              {{scope.row.unit == 1?'每人':scope.row.unit == 2?'每条':scope.row.unit == 3?'每密度':''}}
            </template>
          </el-table-column>
          <el-table-column prop="currentMax" label="当前上限（分）" v-if="checkColList.indexOf('当前上限（分）') > -1"></el-table-column>
          <el-table-column prop="everydayMax" label="当天上限（分）" v-if="checkColList.indexOf('当天上限（分）') > -1"></el-table-column>
          <el-table-column prop="remark" label="备注" v-if="checkColList.indexOf('备注') > -1" width="200"></el-table-column>
          <el-table-column prop="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
            <el-space>
              <el-link type="primary" @click="handleEdit(scope.$index,scope.row)">编辑</el-link>
              <el-link type="success" v-if="scope.row.state == 0"  @click="updateState(scope.$index,scope.row, 1)">启用</el-link>
              <el-link type="warning" v-if="scope.row.state == 1"  @click="updateState(scope.$index,scope.row, 0)">停用</el-link>
            </el-space>

            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getIntegralRulePageList, updateIntegralRule
} from '../../api/url'
import { getFormData, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import IntegralRuleDialog from "@/views/talent/components/IntegralRuleDialog";

export default {
  name: "IntegralRule",
  components: { BtnGroup },
  data() {
    return {
      updateTime: '',

      stateArray: [
        {label: '不限', value: -1},
        {label: '已下架', value: 0},
        {label: '已上架', value: 1},
      ],
      state: -1,

      actionArray: [
        {label: '不限', value: -1},
        {label: '聊天', value: 1},
        {label: '纸条', value: 2},
        {label: '动态', value: 3},
      ],
      action: -1,

      preTypeArray: [
        {label: '不限', value: -1},
        {label: '奖励', value: 1},
        {label: '惩罚', value: 2},
      ],
      preType: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['奖惩类型', '行为', '奖惩操作', '积分数量', '单位', '当前上限（分）', '当天上限（分）', '备注', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      idArray: [],

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      // this.isChecked = true;
      this.preType = -1;
      this.action = -1;
      this.state = -1;
      // this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['preType'] = this.preType;
      param['action'] = this.action;
      param['state'] = this.state;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getIntegralRulePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          this.pageDataList = data.data.records;
          this.totalRow = data.data['total'];
          this.pageSize = data.data['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    // toggleSelection(row, column, cell, event) {
    //   if(column.type == 'selection') {
    //     this.$refs.multipleTableRef.toggleRowSelection(row)
    //   }
    //   //更新用户日志
    //   if(column.label == '用户日志') {
    //     Dialog.open({
    //       title: '用户日志',
    //       component: UserLogDialog,
    //       data: {
    //         id: row.userId
    //       },
    //       close: () => {
    //         row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
    //       }
    //     })
    //   }
    //
    // },
    //
    // showImg(idx, list) {
    //   let imgList = []
    //   for(let i=0; i< list.length; i++) {
    //     imgList.push(list[i].img)
    //   }
    //   ImgViewer.open({
    //     imgList,
    //     imgIndex: idx
    //   })
    // },

    //编辑
    handleEdit(index, row) {
      let ruleForm = Object.assign({},row)
      Dialog.open({
        title: '奖品编辑',
        component: IntegralRuleDialog,
        data: {
          ruleForm: ruleForm,
          width: '500px'
        },
        confirm: (result) => {
          row.integral = result.integral
          row.currentMax = result.currentMax
          row.everydayMax = result.everydayMax
          row.state = result.state
        }
      })
    },


    updateState(idx, row, state) {
      let param = {}
      param['id'] = row.id
      param['integral'] = row.integral
      param['currentMax'] = row.currentMax
      param['everydayMax'] = row.everydayMax
      param['state'] = state
      postFormData(updateIntegralRule, param).then((data) => {
        let {code, msg} = data;
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          row.state = state
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
      }).catch(()=>{
      })
    }



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
